var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEscalationOutlined = function SvgIconEscalationOutlined(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#FFF",
    d: "M17.764 14.016a1.111 1.111 0 0 0-.804-.311H7.854c-1.43 0-1.43 2.223 0 2.223h6.47l-13 12.938c-.224.222-.313.444-.313.622-.045.311.045.622.313.934 4.423 4.223 10.632 6.046 16.619 4.535 10.99-2.801 16.44-15.65 10.811-25.432C23.036-.3 9.454-1.812 1.368 5.925c-1.027.977.536 2.578 1.564 1.555 4.423-4.268 10.99-5.646 16.709-3.2 5.54 2.356 9.158 7.913 9.158 13.87 0 5.958-3.663 11.516-9.158 13.872-5.361 2.312-11.482 1.2-15.86-2.445l12.107-12.049v6.439c0 1.423 2.234 1.423 2.234 0v-9.195a.948.948 0 0 0-.358-.756z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEscalationOutlined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-escalation-outlined.2dca31ff05484c0978f62daecd25d8ef.svg";